/* eslint-disable no-restricted-imports */
import { B2B } from '@/components/blocks/B2B';
import { OneClick } from '@/components/blocks/OneClick';
import { ProductDetailsAddToCart } from '@/components/blocks/ProductDetails/AddToCart';
import { Box, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { ProductDetailsAttributes } from './Attributes';
import { DpDrawer } from '@/components/blocks/DpDrawer';
import { useProductDetails } from '@/data/Content/ProductDetails';
import { ContentContext } from '@/data/context/content';

export const ProductDetailsDrawer = () => {
	const { selection } = useContext(ContentContext) as ReturnType<typeof useProductDetails>;
	const [open, setOpen] = useState(false);
	const toggleDrawer = (newOpen: boolean) => () => {
		setOpen(newOpen);
	};
	const tallaSeleccionada = selection?.attrsByIdentifier?.Talla;

	return (
		<Box sx={{ py: '7px' }}>
			<Box onClick={() => setOpen(true)}></Box>
			{tallaSeleccionada ? (
				<Box sx={{ py: '7px' }}>
					{' '}
					<ProductDetailsAddToCart isDrawer={false} />
				</Box>
			) : (
				<OneClick
					onClick={() => setOpen(true)}
					sx={{ backgroundColor: '#727272', '&:hover': { color: 'white !important' } }}
				>
					<B2B is={false}>
						<Typography sx={{ color: 'white !important', fontWeight: 'bold' }}>
							{'Selecciona una talla'}
						</Typography>
					</B2B>
				</OneClick>
			)}

			<DpDrawer title="Selecciona una talla" open={open} onClose={toggleDrawer(false)}>
				<ProductDetailsAttributes isDrawer={true} />
				<Box sx={{ paddingBottom: '7px', marginTop: '20px' }}>
					<ProductDetailsAddToCart isDrawer={false} />
				</Box>
			</DpDrawer>
		</Box>
	);
};
